import { formatTime } from '@/utils/formatters';

interface PendingTasksRefreshControlsProps {
  lastUpdated: string | null;
  onRefresh: () => void;
  isRefreshing: boolean;
}

export function PendingTasksRefreshControls({
  lastUpdated,
  onRefresh,
  isRefreshing,
}: PendingTasksRefreshControlsProps) {
  return (
    <div className="flex items-center gap-3">
      <span className="num text-[12.5px] text-muted-foreground">
        Last updated: {lastUpdated ? formatTime(lastUpdated) : '-'}
      </span>
      <button
        type="button"
        onClick={onRefresh}
        disabled={isRefreshing}
        className="flex h-9 items-center gap-1.5 rounded-lg border border-border px-3 text-[13px] text-muted-foreground hover:bg-accent hover:text-foreground disabled:cursor-not-allowed disabled:opacity-50"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className={isRefreshing ? 'animate-spin' : ''}
        >
          <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
          <path d="M21 3v5h-5" />
          <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
          <path d="M8 16H3v5" />
        </svg>
        Refresh
      </button>
    </div>
  );
}
